// extracted by mini-css-extract-plugin
export default {"safeAreaSpacer":"safeAreaSpacer--M9RvV"};